import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const BackButtonContext = createContext();

export const useBackButton = () => {
  const context = useContext(BackButtonContext);
  if (!context) {
    throw new Error('useBackButton must be used within a BackButtonProvider');
  }
  return context;
};

export const BackButtonProvider = ({ children }) => {
  const [backButtonInfo, setBackButtonInfo] = useState({
    text: null,
    link: null,
    onClick: null
  });

  const setBackButton = useCallback((text, link, onClick = null) => {
    setBackButtonInfo({ text, link, onClick });
  }, []);

  const clearBackButton = useCallback(() => {
    setBackButtonInfo({ text: null, link: null, onClick: null });
  }, []);

  const value = useMemo(() => ({
    backButtonInfo,
    setBackButton,
    clearBackButton
  }), [backButtonInfo, setBackButton, clearBackButton]);

  return (
    <BackButtonContext.Provider value={value}>
      {children}
    </BackButtonContext.Provider>
  );
};